const LABELS = {
  GET_STARTED: "Get Started",
  MY_ACCOUNT: "My Account",
  SIGN_IN_JOIN: "Sign In / Join",
  SEARCH: "Search",
  SEARCH_PLACEHOLDER: "What can we help you find?"
};
const ARIA_LABELS = {
  GET_STARTED: "Get started",
  MY_ACCOUNT: "My account",
  SIGN_IN_JOIN: "Sign in or join",
  NAVIGATION_MENU: "Navigation menu button",
  LOGO: "Quicken Loans logo",
  SEARCH_ICON: "Search"
};
const SOURCE_KEY = "sourceid";
const SOURCE_PREFIX = "qlwebsite_";
const COOKIE_EXPIRATION_DAYS = 365;
const COOKIE_EXPIRATION_TIME = COOKIE_EXPIRATION_DAYS * 24 * 60 * 60 * 1e3;
const fallbackGlobalObject = {
  globalNav: {
    nodes: [
      {
        databaseId: 8830,
        label: "Learning Center",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 9561,
              label: "All Topics",
              path: "/learn",
              url: "https://www.quickenloans.com/learn",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8833,
              label: "Home Buying",
              path: "/learn/home-buying",
              url: "https://www.quickenloans.com/learn/home-buying",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8831,
              label: "Mortgages",
              path: "/learn/mortgages",
              url: "https://www.quickenloans.com/learn/mortgages",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8835,
              label: "Loans",
              path: "/learn/loans",
              url: "https://www.quickenloans.com/learn/loans",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8837,
              label: "Refinancing",
              path: "/learn/refinancing",
              url: "https://www.quickenloans.com/learn/refinancing",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8839,
              label: "Home Selling",
              path: "/learn/home-selling",
              url: "https://www.quickenloans.com/learn/home-selling",
              parentDatabaseId: 8830
            },
            {
              databaseId: 8840,
              label: "Real Estate",
              path: "/learn/real-estate",
              url: "https://www.quickenloans.com/learn/real-estate",
              parentDatabaseId: 8830
            }
          ]
        }
      },
      {
        databaseId: 8841,
        label: "Refinance",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 8842,
              label: "Refinance Guide",
              path: "/learn/what-is-refinancing",
              url: "https://www.quickenloans.com/learn/what-is-refinancing",
              parentDatabaseId: 8841
            },
            {
              databaseId: 8843,
              label: "Lower Your Payment",
              path: "/learn/how-to-lower-monthly-mortgage-payment",
              url: "https://www.quickenloans.com/learn/how-to-lower-monthly-mortgage-payment",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9541,
              label: "Pay Off Your Mortgage Faster",
              path: "/learn/paying-off-mortgage",
              url: "https://www.quickenloans.com/learn/paying-off-mortgage",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9540,
              label: "Reasons To Refinance",
              path: "/learn/reasons-to-refinance-your-home",
              url: "https://www.quickenloans.com/learn/reasons-to-refinance-your-home",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9539,
              label: "Consolidate Your Debt",
              path: "/learn/what-is-debt-consolidation",
              url: "https://www.quickenloans.com/learn/what-is-debt-consolidation",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9538,
              label: "Get Cash From Your Home",
              path: "/learn/cash-out-refinance",
              url: "https://www.quickenloans.com/learn/cash-out-refinance",
              parentDatabaseId: 8841
            },
            {
              databaseId: 9537,
              label: "Refinance Your Property",
              path: "/learn/refinance-investment-property",
              url: "https://www.quickenloans.com/learn/refinance-investment-property",
              parentDatabaseId: 8841
            }
          ]
        }
      },
      {
        databaseId: 8844,
        label: "Buy A Home",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 8845,
              label: "Home Buyer’s Guide",
              path: "/learn/should-i-buy-a-house",
              url: "https://www.quickenloans.com/learn/should-i-buy-a-house",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9542,
              label: "First-time Homebuyer",
              path: "/learn/steps-to-buying-a-house",
              url: "https://www.quickenloans.com/learn/steps-to-buying-a-house",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9543,
              label: "Buying a Vacation Home",
              path: "/learn/how-to-buy-a-vacation-home",
              url: "https://www.quickenloans.com/learn/how-to-buy-a-vacation-home",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9544,
              label: "Relocation",
              path: "/learn/moving-to-another-state",
              url: "https://www.quickenloans.com/learn/moving-to-another-state",
              parentDatabaseId: 8844
            },
            {
              databaseId: 9545,
              label: "Real Estate Investors",
              path: "/learn/investment-property",
              url: "https://www.quickenloans.com/learn/investment-property",
              parentDatabaseId: 8844
            }
          ]
        }
      },
      {
        databaseId: 9546,
        label: "Loan Options",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 9547,
              label: "Compare All Loan Options",
              path: "/home-loans",
              url: "https://www.quickenloans.com/home-loans",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9548,
              label: "Adjustable Rate Mortgage",
              path: "/home-loans/adjustable-rate-mortgage",
              url: "https://www.quickenloans.com/home-loans/adjustable-rate-mortgage",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9549,
              label: "30-Year Fixed Mortgage",
              path: "/home-loans/30-year-fixed",
              url: "https://www.quickenloans.com/home-loans/30-year-fixed",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9550,
              label: "15-Year Fixed Mortgages",
              path: "/home-loans/15-year-fixed",
              url: "https://www.quickenloans.com/home-loans/15-year-fixed",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9551,
              label: "FHA Loans",
              path: "/home-loans/fha-loan",
              url: "https://www.quickenloans.com/home-loans/fha-loan",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9552,
              label: "FHA Streamline",
              path: "/home-loans/fha-streamline",
              url: "https://www.quickenloans.com/home-loans/fha-streamline",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9553,
              label: "VA Loans",
              path: "/home-loans/va-loan",
              url: "https://www.quickenloans.com/home-loans/va-loan",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9554,
              label: "USDA Loan",
              path: "/learn/benefits-usda-loans",
              url: "https://www.quickenloans.com/learn/benefits-usda-loans",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9555,
              label: "Jumbo Loans",
              path: "/home-loans/jumbo-mortgage",
              url: "https://www.quickenloans.com/home-loans/jumbo-mortgage",
              parentDatabaseId: 9546
            },
            {
              databaseId: 9556,
              label: "Custom Term Loan",
              path: "/home-loans/custom-mortgage-yourgage",
              url: "https://www.quickenloans.com/home-loans/custom-mortgage-yourgage",
              parentDatabaseId: 9546
            }
          ]
        }
      },
      {
        databaseId: 8873,
        label: "Mortgage Rates",
        path: "/mortgage-rates",
        url: "https://www.quickenloans.com/mortgage-rates",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 9557,
        label: "Calculators",
        path: "#",
        url: "#",
        parentDatabaseId: 0,
        childItems: {
          nodes: [
            {
              databaseId: 9558,
              label: "All Calculators",
              path: "/calculators",
              url: "https://www.quickenloans.com/calculators",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9562,
              label: "Refinance Calculator",
              path: "/calculators/refinance-calculator",
              url: "https://www.quickenloans.com/calculators/refinance-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9560,
              label: "Purchase Mortgage Calculator",
              path: "/calculators/mortgage-calculator",
              url: "https://www.quickenloans.com/calculators/mortgage-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9563,
              label: "Rent vs. Buy Calculator",
              path: "/calculators/rent-vs-buy-calculator",
              url: "https://www.quickenloans.com/calculators/rent-vs-buy-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9559,
              label: "Home Affordability Calculator",
              path: "/calculators/home-affordability-calculator",
              url: "https://www.quickenloans.com/calculators/home-affordability-calculator",
              parentDatabaseId: 9557
            },
            {
              databaseId: 9564,
              label: "Amortization Calculator",
              path: "/calculators/amortization-calculator",
              url: "https://www.quickenloans.com/calculators/amortization-calculator",
              parentDatabaseId: 9557
            }
          ]
        }
      }
    ]
  },
  globalAccount: {
    nodes: [
      {
        databaseId: 8859,
        label: "My Dashboard",
        path: "https://accounts.quickenloans.com/",
        url: "https://accounts.quickenloans.com/",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8860,
        label: "Home Buying Guide",
        path: "https://accounts.quickenloans.com/milestone",
        url: "https://accounts.quickenloans.com/milestone",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8861,
        label: "Favorites",
        path: "https://accounts.quickenloans.com/favorites",
        url: "https://accounts.quickenloans.com/favorites",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8862,
        label: "Perks",
        path: "https://accounts.quickenloans.com/perks",
        url: "https://accounts.quickenloans.com/perks",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8863,
        label: "Profile",
        path: "https://accounts.quickenloans.com/profile",
        url: "https://accounts.quickenloans.com/profile",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8864,
        label: "Settings",
        path: "https://accounts.quickenloans.com/settings",
        url: "https://accounts.quickenloans.com/settings",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      },
      {
        databaseId: 8865,
        label: "Sign Out",
        path: "https://accounts.quickenloans.com/api/auth/logout",
        url: "https://accounts.quickenloans.com/api/auth/logout",
        parentDatabaseId: 0,
        childItems: {
          nodes: []
        }
      }
    ]
  }
};
const CRITERIA_TYPE = "credit-score";
const OFFER_CTA_PREFIX = "On";
const MKT_CONTAINER_ID = "marketplace-container";
const FOCUS_OUTLINE_CLASS = "focus-outline";
const HOST_PLATFORM = {
  GATSBY: "gatsby",
  NEXT: "next"
};
const LINK_TYPES = {
  GATSBY: "to",
  NEXT: "href"
};
const HYBRID_BREAKPOINTS = {
  MIN_WIDTH: 1200,
  MAX_WIDTH: 1439
};
const DRAWER_TRANSITION_DURATION = 400;
const DRAWER_TRANSITION_DURATION_DESKTOP = {
  enter: 300,
  exit: 300
};
const SKELETON_VARIANTS = {
  TEXT: "text",
  CIRCULAR: "circular",
  RECTANGULAR: "rectangular",
  ROUNDED: "rounded",
  ROUNDED_RECT: "rounded-rect"
};
const NAVIGATION_BAR_ACTIONS = {
  TIER_1: "TIER_1",
  TIER_2: "TIER_2",
  SEARCH_BAR: "SEARCH_BAR",
  CLOSE_ALL: "CLOSE_ALL"
};
const USER_SESSION_COOKIE = "userSession";
const TEST_MODE_QUERY_PARAM = "market-test";
const TOTAL_SKELETON_LOADER_CARDS = 3;
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARIA_LABELS,
  COOKIE_EXPIRATION_DAYS,
  COOKIE_EXPIRATION_TIME,
  CRITERIA_TYPE,
  DRAWER_TRANSITION_DURATION,
  DRAWER_TRANSITION_DURATION_DESKTOP,
  FOCUS_OUTLINE_CLASS,
  HOST_PLATFORM,
  HYBRID_BREAKPOINTS,
  LABELS,
  LINK_TYPES,
  MKT_CONTAINER_ID,
  NAVIGATION_BAR_ACTIONS,
  OFFER_CTA_PREFIX,
  SKELETON_VARIANTS,
  SOURCE_KEY,
  SOURCE_PREFIX,
  TEST_MODE_QUERY_PARAM,
  TOTAL_SKELETON_LOADER_CARDS,
  USER_SESSION_COOKIE,
  fallbackGlobalObject
}, Symbol.toStringTag, { value: "Module" }));
export {
  ARIA_LABELS as A,
  CRITERIA_TYPE as C,
  DRAWER_TRANSITION_DURATION_DESKTOP as D,
  FOCUS_OUTLINE_CLASS as F,
  HYBRID_BREAKPOINTS as H,
  LABELS as L,
  MKT_CONTAINER_ID as M,
  NAVIGATION_BAR_ACTIONS as N,
  OFFER_CTA_PREFIX as O,
  SKELETON_VARIANTS as S,
  TOTAL_SKELETON_LOADER_CARDS as T,
  USER_SESSION_COOKIE as U,
  DRAWER_TRANSITION_DURATION as a,
  HOST_PLATFORM as b,
  LINK_TYPES as c,
  SOURCE_PREFIX as d,
  TEST_MODE_QUERY_PARAM as e,
  SOURCE_KEY as f,
  COOKIE_EXPIRATION_TIME as g,
  fallbackGlobalObject as h,
  index as i,
  COOKIE_EXPIRATION_DAYS as j
};
//# sourceMappingURL=index-BIblv54e.js.map
